angular.module('bribac.components.schedulePeriodEditor', [
  'ui.bootstrap',
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.api',
  'bribac.services.errorUtils',
  'bribac.components.whenLoaded',
  'bribac.components.scheduleDetails'
])

  .component('schedulePeriodEditor', {
    templateUrl: 'schedule-period-editor-component.html',
    controller: 'SchedulePeriodEditorComponentCtrl',
    bindings: {
      schedulePeriod: '<',
      // If `scheduleFromTemplates` is true, a list of the schedule templates
      // will be shown to be picked from, if it's false a schedule editor will
      // be shown so a new or existing schedule can be edited.
      scheduleFromTemplates: '<',
      // If `saveToApi` is true the schedule period will be PUT/POSTed to the
      // API when saving, if it's false the schedule period will be passed
      // directly to the success callback instead.
      saveToApi: '<',
      successCallback: '<',
      cancelCallback: '<'
    }
  })

  .controller('SchedulePeriodEditorComponentCtrl', function(
    $scope,
    $window,
    $translate,
    api,
    KINDS,
    errorUtils
  ) {
    var $ctrl = this
    var now = new Date()
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    var isoStringMillisecondsRegex = /\.\d{3}/

    $ctrl.datePickerOpen = {
      startDate: false,
      endDate: false
    }

    $ctrl.toggleDatePicker = function(picker) {
      $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
    }

    $ctrl.startDateOptions = {
      minDate: today
    }
    $ctrl.endDateOptions = {}

    $ctrl.cleanSubmitError = function () {
        if ($ctrl.form) {
            $ctrl.form._submitError = '';
        }
    };

    function resetForm() {
      if ($ctrl.form) {
        $ctrl.form.$setUntouched()
        $ctrl.form.$setPristine()
      }
    }

    $ctrl.subFormChangedCallback = function () {
      $ctrl.cleanSubmitError();
    };

    function submitSuccess(request) {
      $ctrl.form._submitSuccess = 'Saved ' + request.data.schedule.name
      resetForm()
      $ctrl.successCallback(request.data)
    }

    function isTodayInPeriod(startDate, endDate) {
      return startDate.getTime() <= today.getTime() && endDate.getTime() >= today.getTime()
    }

    function getWeekNumber(date) {
      const currentDate = new Date()
      const days = Math.round((currentDate - date) / (24 * 60 * 60 * 1000))
      return Math.ceil(days / 7)
    }

    function getScheduleRepeat(startDate, repeatCycle) {
      const currWeek = getWeekNumber(startDate)
      return (currWeek - 1) % repeatCycle
    }

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid || !$ctrl.editableSchedulePeriod.schedule.weekdays.length) {
        $form._submitError = 'formErrors.invalidFields';
        $scope.$broadcast('submitError');
        return
      }

      var startDate = new Date($ctrl.schedulePeriod.startDate)
      var endDate = new Date($ctrl.schedulePeriod.endDate)

      $ctrl.editableSchedulePeriod.schedule.fixedTimes = $ctrl.editableSchedulePeriod.schedule.fixedTimes.filter(function(time) { return !!time })
      $ctrl.editableSchedulePeriod.reschedule = false

      /*
       * We are checking whether either the old period (schedulePeriod) or the updated period (editableSchedulePeriod)
       * are applied for today (or both).
       * startDate and endDate are always at midnight time of the given day
       */
      if (parseInt($ctrl.schedulePeriod.id) && (isTodayInPeriod(startDate, endDate) ||
       isTodayInPeriod($ctrl.editableSchedulePeriod.startDate, $ctrl.editableSchedulePeriod.endDate))) {

        const appliedThisWeek = getScheduleRepeat($ctrl.editableSchedulePeriod.startDate, $ctrl.editableSchedulePeriod.repeatCycle) === 0

        /*
         * Schedule is affecting todays tests -> we need to handle possible need to re-schedule
         * We are checking for any change done in the schedule prescription or if the startDate was moved
         * outside today.
         */
        if (appliedThisWeek && !angular.equals($ctrl.editableSchedulePeriod.schedule, $ctrl.schedulePeriod.schedule) ||
          $ctrl.editableSchedulePeriod.startDate.getTime() > today.getTime()) {
            // Ask for re-schedule
            var answer = $window.confirm($translate.instant('components.schedulePeriodEditor.question.recreateTests', null, "", "", ""))
            $ctrl.editableSchedulePeriod.reschedule = answer
        } else {
          // No changes -> No need to re-schedule
          $ctrl.editableSchedulePeriod.reschedule = false
        }
      }

      var schedulePeriod = angular.copy($ctrl.editableSchedulePeriod)
      schedulePeriod.startDate = schedulePeriod.startDate.toISOString().replace(isoStringMillisecondsRegex, '')
      schedulePeriod.endDate = schedulePeriod.endDate.toISOString().replace(isoStringMillisecondsRegex, '')
      schedulePeriod.schedule.fixedTimes = schedulePeriod.schedule.fixedTimes.filter(function(time) { return !(!time.time || !time.time.trim() || time.time === 'null') })

      $form._submitSuccess = ''
      $form._submitError = ''

      if ($ctrl.saveToApi) {
        $form._submitting = true

        api[$ctrl.editableSchedulePeriod.id ? 'put' : 'post'](KINDS.SCHEDULE_PERIOD, schedulePeriod)
        .finally(function() { $form._submitting = false })
        .then(submitSuccess, function error(request) {
          $form._submitError = errorUtils.parseErrorResponse(request)
        })
      } else {
        submitSuccess({data: schedulePeriod})
      }
    }

    $ctrl.unbindStartDateWatcher = $scope.$watch('$ctrl.editableSchedulePeriod.startDate', function(newVal) {
      $ctrl.endDateOptions.minDate = newVal || today
    })

    $ctrl.$onChanges = function(changes) {
      if (changes.schedulePeriod) {
        // Reset state since the schedule period instance we're editing has changed.
        resetForm()
        var copy = angular.copy($ctrl.schedulePeriod)
        // Must use dates so it's compatible with uib-datepicker.
        if (copy.startDate) copy.startDate = new Date(copy.startDate)
        if (copy.endDate) copy.endDate = new Date(copy.endDate)
        $ctrl.editableSchedulePeriod = copy
      }
    }

    $ctrl.schedulesPromise = api.get(KINDS.SCHEDULE).then(function(request) {
      $ctrl.schedules = request.data.list
    });

    $ctrl.invalidateAndTouchForm = function(form) {
      form.$invalid = true;
      form.$touched = true;
    };

    $ctrl.$onDestroy = function() {
      $ctrl.unbindStartDateWatcher()
    };
  });
